<section class="d-flex">
    <mat-card class="col-2">
        <mat-card-header>
            <mat-card-title>Date</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-list role="list">
                <mat-list-item role="listitem" (click)="filter('all')" [ngClass]="{active: 'all' === selectedFilter}">
                    <div class="col">
                        All
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" (click)="filter('today')"
                               [ngClass]="{active: 'today' === selectedFilter}"
                                id="filterToday">
                    <div class="col">
                        Today
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" (click)="filter('yesterday')"
                               [ngClass]="{active: 'yesterday' === selectedFilter}"
                                id="filterYesterday">
                    <div class="col">
                        Yesterday
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" (click)="filter('week')"
                               [ngClass]="{active: 'week' === selectedFilter}"
                               id="filterWeek">
                    <div class="col">
                        Week
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" (click)="filter('month')"
                               [ngClass]="{active: 'month' === selectedFilter}"
                                id="filterMonth">
                    <div class="col">
                        Month
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" (click)="filter('range')"
                               [ngClass]="{active: 'range' === selectedFilter}"
                                id="rangeFilter">
                    <div class="col">
                        Date Range
                    </div>
                </mat-list-item>
            </mat-list>
            <mat-form-field appearance="fill" class="col" *ngIf="selectedFilter==='range'">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate placeholder="Start date" [(ngModel)]="startFilter">
                    <input matEndDate placeholder="End date" [(ngModel)]="endFilter" (ngModelChange)="onDateChange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </mat-card-content>
    </mat-card>
    <mat-card class="col-10 ">
        <mat-card-header>
            <mat-card-title>Reports</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>
            <span *ngIf="loginService.getActiveUserSubject() | async as user">
                <mat-form-field *ngIf="(user.cuid)=== 'CMC'" class="bg-light col-2 search-input" id="search-select">
                    <mat-select [(value)]="cuid" (selectionChange)="getLogItems()" id="selectCU">
                            <mat-option *ngFor="let cu of creditUnions | async | orderBy: 'cuid'" [value]="cu.cuid">
                                {{cu.cuid + ' - ' + cu.name}}
                            </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
            <button class="exportButton" mat-raised-button [color]="'primary'" (click)="export()">Export</button>
            </div>
            <mat-list role="list">
                <table mat-table [dataSource]="dataSource" matSort class="table"
                       matSortActive="date" matSortDirection="desc">
                    <ng-container [matColumnDef]="column.value" *ngFor="let column of displayedColumns">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.label}} </th>
                        <td mat-cell *matCellDef="let element" [ngSwitch]="true">
<!--                            <span *ngSwitchCase="column.label === 'Date'">-->
<!--                                {{element['startTime'] |date: 'M/dd/yyyy'}}-->
<!--                            </span>-->
                            <span *ngSwitchCase="column.value === 'startTime'">
                               {{element['startTime'] |date: 'short'}}<span *ngIf=" element['endTime'] !== '+10000-01-01T00:00:00'"> - {{element['endTime'] |date: 'shortTime'}}</span>
                            </span>
                            <span *ngSwitchCase="column.value === 'user'">
                                {{element['user'] | toName: (allUsers | async):'TicketUser'}}
                            </span>
                            <span *ngSwitchDefault>{{element[column.value]}}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columns" class="w-100"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns;" class="w-100"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[10,25,50,100, dataSource.data.length]"></mat-paginator>
            </mat-list>
        </mat-card-content>
    </mat-card>
</section>

